var firebase = require("firebase/app");
require("firebase/auth");
var config = {
  apiKey: "AIzaSyAYdPjFz_MHcTyPFXMDp47Z_8FMhNSuu9o",
  authDomain: "api-springboard.firebaseapp.com",
  databaseURL: "https://api-springboard.firebaseio.com",
  projectId: "api-springboard",
  storageBucket: "api-springboard.appspot.com",
  messagingSenderId: "627812792150",
  appId: "1:627812792150:web:fd540507f7c50f667888f7",
  measurementId: "G-BDLPXPNB9Y",
};
export default firebase.initializeApp(config);